/**
 * Módulo de analytics — KPIs avanzados de mantenimiento
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo analytics
 */
export function createAnalyticsModule({ authenticatedRequest }) {
  return {
    /**
     * Obtiene KPIs de analytics con filtros opcionales
     *
     * @param {Object} [params] - Parámetros de consulta
     * @param {string} [params.fecha_inicio] - Fecha inicio (YYYY-MM-DD)
     * @param {string} [params.fecha_termino] - Fecha término (YYYY-MM-DD)
     * @param {number} [params.equipo_id] - Filtrar por equipo
     * @param {number} [params.tipo_mantenimiento_id] - Filtrar por tipo mantenimiento
     * @param {number} [params.categoria_equipo_id] - Filtrar por categoría
     * @returns {Promise<{success: boolean, data: Object, filtros: Object}>}
     */
    async getAnalyticsKpis(params = {}) {
      const qs = new URLSearchParams(params).toString();
      return await authenticatedRequest(qs ? `/api/analytics/kpis?${qs}` : '/api/analytics/kpis');
    }
  };
}
